import api from './api'

const URL = '/api/service'
let service = {}

service.getServicesMain = function () {
  return api.get(`${URL}/v2/order/main`).then(res => res.data).catch(err => {
    return err.response
  })
}

export default service
